<script setup lang="ts">
const { getTranslation } = useLanguage();

const { main: { why: { title, cards } } } = getTranslation();

const PACKAGE = 5;
const DELIMITER = 3;
</script>

<template>
  <section>
    <CommonContainer>
      <h2 class="font-semibold leading-default text-4xl 2xs:text-6xl sm:text-7xl hd:text-heading-xl">
        {{ title.base }}<sup class="text-2xl 2xs:text-3xl sm:text-5xl">
          {{ title.symbol }}
        </sup>{{ title.extra }}
      </h2>

      <div class="sm:grid sm:grid-cols-6 sm:grid-rows-auto gap-8 xs:gap-6 mt-8 xs:mt-14">
        <CardsBenefitCard
          v-for="(card, idx) in cards"
          :key="idx"
          v-bind="card"
          :class="['my-4 sm:my-0', {
            'col-span-2 row-span-3': idx % PACKAGE < DELIMITER,
            'col-span-3 row-span-2': idx % PACKAGE >= DELIMITER,
          }]"
        />
      </div>
    </CommonContainer>
  </section>
</template>
